module.exports = __webpack_public_path__ + "img/lokac_b.72e446ca.svg";